import React from 'react';
import ElementDataSection from 'components/common/element-data/ElementDataSection';
import BusinessOwner from 'components/common/element-data/parts/BusinessOwner';
import TechnicalOwner from 'components/common/element-data/parts/TechnicalOwner';
import DataSteward from 'components/common/element-data/parts/DataSteward';
import { ElementMetadataSectionName, IElementDataSectionDetails } from 'components/common/element-data/types';
import DataSource from 'components/common/element-data/parts/DataSource';
import LastUpdated from 'components/common/element-data/parts/LastUpdated';
import Engagement from 'components/common/element-data/parts/Engagement';
import LastDataPoint from 'components/common/element-data/parts/LastDataPoint';
import Tags from 'components/common/element-data/parts/Tags';
import useBundleTranslation from 'i18n';
import Projected from 'components/common/element-data/parts/Projected';
import Category from 'components/common/element-data/parts/Category';
import ContentType from 'components/common/element-data/parts/ContentType';
import { getOwnerIconConfig, getSectionElementMetadataSettings } from 'components/common/element-data/functions';

export default function DetailsSection(props: IElementDataSectionDetails) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { settings, ...element } = props;
    const sectionKey: ElementMetadataSectionName = 'details';
    const { sectionMetadataOrder } = getSectionElementMetadataSettings(settings, sectionKey);
    const ownerIconConfig = getOwnerIconConfig(settings, element);

    return (
        <ElementDataSection title={t(`element_data_section_label.${sectionKey}`)} order={sectionMetadataOrder}>
            <Tags {...element} settings={settings} />
            <BusinessOwner {...element} settings={settings} showOwnerIcon={ownerIconConfig.business_owner} />
            <DataSteward {...element} settings={settings} showOwnerIcon={ownerIconConfig.data_steward} />
            <TechnicalOwner {...element} settings={settings} showOwnerIcon={ownerIconConfig.technical_owner} />
            <Projected {...element} settings={settings} />
            <DataSource {...element} settings={settings} />
            <LastUpdated {...element} settings={settings} />
            <ContentType {...element} settings={settings} />
            <Category {...element} settings={settings} />
            <Engagement {...element} settings={settings} />
            <LastDataPoint {...element} settings={settings} />
        </ElementDataSection>
    );
}
